import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo } from './api'
import { sStorage } from '@/utils/storage'
import { Toast } from 'vant'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cid: sStorage.getItem('commonInfo') ? sStorage.getItem('commonInfo').cid : '',
    token: sStorage.getItem('commonInfo') ? sStorage.getItem('commonInfo').token : '',
    customerPhone: '',
    customerName: ''
  },
  mutations: {
    setCid (state, v) {
      state.cid = v
    },
    setToken (state, v) {
      state.token = v
    },
    setCustomerPhone (state, v) {
      state.customerPhone = v
    },
    setCustomerName (state, v) {
      state.customerName = v
    }
  },
  getters: {
    getCommonInfo (state) {
      return {
        cid: state.cid,
        token: state.token
      }
    }
  },
  actions: {
    getUserInfo (context, params) {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中'
      })
      getUserInfo(params).then((result) => {
        toast.clear()
        if (result.status === 200) {
          if (result.data.status.succeed.toString() === '1') {
            const data = result.data.data
            context.commit('setCustomerPhone', data.customer_phone)
            context.commit('setCustomerName', data.customer_name)
          }
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    setCommonData (context, { cid, token }) {
      sStorage.setItem('commonInfo', { cid, token })
      context.commit('setCid', cid)
      context.commit('setToken', token)
    }
  }
})
